import React from "react";
import { I18nContext } from "./I18nProvider";

// HOC for class components - most of this app predates hooks. Injects t / locale / setLocale as
// props. Apply it as the OUTERMOST wrapper so connect() sees the changed props and re-renders:
//    export default withTranslation(connect(mapState, actions)(MyComponent));
export function withTranslation(WrappedComponent) {
   const WithTranslation = (props) => (
      <I18nContext.Consumer>
         {({ t, locale, setLocale }) => (
            <WrappedComponent {...props} t={t} locale={locale} setLocale={setLocale} />
         )}
      </I18nContext.Consumer>
   );

   WithTranslation.displayName = `withTranslation(${
      WrappedComponent.displayName || WrappedComponent.name || "Component"
   })`;

   return WithTranslation;
}

export default withTranslation;
